import * as actions from "../shared/action";

export default actions